export const GET_USER_UPSTREAM_LIST = 'settings/whitelabel/domain';
export const GET_ALL_UPSTREAM_LIST = '/settings/whitelabel/upstream/list';
export const ADD_UPSTREAM = '/settings/whitelabel/domain';
export const REFRESH_DNS_STATUS = '/settings/whitelabel/domain/:domain_uuid';
export const EMAIL_CONFIGURATION = '/settings/config/email';
export const UPLOAD_WORKSPACE_IMG = '/settings/config/upload-img';
export const CONFIG = '/settings/config';
export const WORKSPACE = '/workspace';